import React from "react";
import { TUC_ROUNDS } from "@/components/NextRace";
import { SectionMark } from "@/components/PageHeader";
import { romeToday } from "./eventUtils";

/* Tuscany Urban Cup 2026 — 6 rounds from the official calendar poster (poster itself is the event hero). */
export default function TucCalendar({ lang, n = "02" }) {
    const en = lang === "en";
    const today = romeToday();
    const nextN = TUC_ROUNDS.find((x) => x.date >= today)?.n;
    return (
        <div id="tuc" className="scroll-mt-16" data-testid="tuc-calendar">
            <SectionMark n={n} title={en ? "Championship calendar 2026" : "Calendario campionato 2026"}
                right={<span className="label-mono text-abnormal-paperDim/60">6 {en ? "rounds" : "tappe"}</span>} />
            <ol className="grid sm:grid-cols-2 gap-2" data-testid="tuc-rounds">
                {TUC_ROUNDS.map((r) => {
                    const past = r.date < today;
                    const next = r.n === nextN;
                    return (
                        <li key={r.n} data-testid={`tuc-round-${r.n}`} className={`border px-4 py-3 flex items-center gap-4 ${next ? "border-abnormal-acid bg-abnormal-charcoal" : "border-white/15"} ${past ? "opacity-50" : ""}`}>
                            <span className="font-vt text-[10px] tracking-[0.25em] text-abnormal-acid">R{r.n}</span>
                            <span className="font-display text-3xl leading-none text-abnormal-paper w-[84px]">{r.label}</span>
                            <span className="flex-1 font-display uppercase text-xl leading-none text-abnormal-paper">{r.place}</span>
                            {next && <span className="label-mono bg-abnormal-acid text-black px-2 py-1">{en ? "Next" : "Prossima"}</span>}
                            {past && <span className="label-mono text-abnormal-paperDim/70">{en ? "Done" : "Corsa"}</span>}
                        </li>
                    );
                })}
            </ol>
        </div>
    );
}
